import React from 'react';

export const defaultCartContext: CartContext = {
  products: {},
  cartDrawerOpen: false,
  setContext: () => {},
};

export default React.createContext<CartContext>(defaultCartContext);
